// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IhSo2UgWn88HxxEf6osx{border:1px solid var(--border-neutral-default);background:var(--content-primary-primary-inverted);z-index:10;border-radius:12px;flex-direction:column;flex-grow:1;width:400px;height:calc(100% - 48px);margin:24px;display:flex;position:absolute;top:0;right:0}.iIUaL8S63gsixEckm0aP{justify-content:space-between;align-items:center;padding:18px 16px 18px 24px;display:flex}.NACI5SZzuJQMEZsvnVmj{background:var(--gray-a-15);border-radius:4px;padding:3.5px 8px}.RF99BvS4N0Deblxuht0o{flex-direction:column;flex-grow:1;padding:16px 24px 0;display:flex;overflow:auto}.kr2kz_efM4Uix1A_kG45{gap:8px;padding:16px 24px 24px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectedAction": `IhSo2UgWn88HxxEf6osx`,
	"header": `iIUaL8S63gsixEckm0aP`,
	"title": `NACI5SZzuJQMEZsvnVmj`,
	"content": `RF99BvS4N0Deblxuht0o`,
	"actions": `kr2kz_efM4Uix1A_kG45`
};
export default ___CSS_LOADER_EXPORT___;
